export const ORDERS_MESASGES = {
  TrackingNumberAdded: 'Tracking Number Added Successfully',
  OrderRejected: 'Order Rejected Successfully',
  OrderAccepted: 'Order Accepted Successfully',
  OrderCancelled: 'Order Cancelled Successfully',
  OrderNoteChanged: 'Order Note Changed Successfully',
};
